import { useState, useEffect, useRef } from "react"; // Importa useRef
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Mateus Silva",
    city: "Nova União - Ro",
    text: "A Webnorte oferece um atendimento excepcional, tanto presencial quanto online. A equipe é atenciosa, rápida e sempre disposta a ajudar. Além disso, os serviços prestados são de altíssima qualidade, demonstrando profissionalismo e compromisso com o cliente.",
    stars: 5,
  },
  {
    name: "Marconi Bernardes",
    city: "Nova União - Ro",
    text: "Sem dúvidas o melhor provedor de internet da região central de Rondônia, um atendimento super diferenciado, super recomendo, e ainda tem vários serviços adicionais, vc pode contratar um pacote a assistir os filmes e séries de maiores sucessos mundiais. Web norte telecom, quem conhece nunca esquece, e principalmente nunca mais troca de provedor.",
    stars: 5,
  },
  {
    name: "Marllon Kristian",
    city: "Vale do Paraíso - Ro",
    text: "Internet ótima. Bom nos atendimentos tanto na parte da fibra óptica na cidade como na fibra óptica rural. Funcionando 24 horas. E tem ótimos funcionários de qualidade. Muito bom 🛜📶!",
    stars: 5,
  },
  {
    name: "Lara kauany",
    city: "Vale do Paraíso - Ro",
    text: "São super comunicativos com clientes fazendo com que temos mais confiança no trabalho deles!!",
    stars: 5,
  },
  {
    name: "Willame Freire Correia",
    city: "Nova União - Ro",
    text: "Com a web norte, tenho a melhor experiência. No meu caso que trabalho em home office, a mesma tem atendido as minhas expectativas. Realizando minhas reunião, sem perda de conectividade e com a menor latência.",
    stars: 5,
  },
];

export default function TestimonialsSection() {
  const scrollRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      if (scrollRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
        if (scrollLeft + clientWidth >= scrollWidth - 10) {
          scrollRef.current.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          // Scroll one card width roughly
          scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
        }
      }
    }, 4000);
    return () => clearInterval(timer);
  }, [isHovered]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { clientWidth } = scrollRef.current;
      const scrollAmount = direction === "left" ? -(clientWidth / 2) : (clientWidth / 2);
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <section id="depoimentos" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="font-poppins font-bold text-3xl sm:text-4xl text-foreground mb-4">
            O que nossos <span className="text-primary">clientes dizem</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Milhares de famílias conectadas e satisfeitas
          </p>
        </motion.div>

        <div 
          className="relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div 
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-8 pt-4 hide-scrollbar"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {testimonials.map((testi, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                viewport={{ once: true }}
                className="snap-center shrink-0 w-[85vw] md:w-[calc(50%-0.75rem)] lg:w-[calc(33.333%-1rem)] glass-card rounded-2xl p-8 sm:p-10 text-center relative flex flex-col justify-between"
              >
                <div>
                  <Quote className="h-10 w-10 text-primary/50 mx-auto mb-4" />
                  <p className="text-base sm:text-lg text-foreground leading-relaxed mb-6 font-inter italic">
                    "{testi.text}"
                  </p>
                </div>
                <div>
                  <div className="flex justify-center gap-1 mb-3">
                    {Array.from({ length: testi.stars }).map((_, idx) => (
                      <Star key={idx} className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                    ))}
                  </div>
                  <p className="font-poppins font-semibold text-foreground">
                    {testi.name}
                  </p>
                  <p className="text-sm text-muted-foreground">{testi.city}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="flex items-center justify-center gap-4 mt-2">
            <button
              onClick={() => scroll("left")}
              className="h-10 w-10 rounded-full glass-card flex items-center justify-center hover:bg-primary hover:text-white transition-all text-muted-foreground shadow-sm"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={() => scroll("right")}
              className="h-10 w-10 rounded-full glass-card flex items-center justify-center hover:bg-primary hover:text-white transition-all text-muted-foreground shadow-sm"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}